<template>
  <validation-observer
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'employment-status'"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <!-- EMPLOYMENT STATUS GENERIC -->
      <form-row
        :label="!isAdditional ? 'What is your employment status?' : 'What is their employment status?'"
        :help-text="computedHelpText"
      >
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_employment-status`"
          name="Employment Status"
          :rules="{ is_not: { other: null } }"
        >
          <radio
            v-model="employmentStatusGenericModel"
            :name="`${stepId}.employment-status`"
            :data-test="fieldTrackerId.main"
            :items="employmentStatusGeneric"
            :error="failed"
            :error-messages="failed ?
              [`Please select ${isAdditional ? 'their' : 'your'} employment status.`] :
              []"
            column
            return-object
          />
        </validation-provider>
      </form-row>
      <!-- EMPLOYMENT STATUS OTHER -->
      <form-row
        v-if="employmentStatusGenericModel !== null && !constants.EMPLOYMENT_STATUS_FAVORITES.includes(employmentStatusGenericModel)"
        gap="16"
      >
        <validation-provider
          v-slot="{ errors }"
          :vid="`${stepId}_employment-status`"
          name="Employment Status (Other)"
          rules="listOptionRequired"
        >
          <qz-select
            v-model="questionData.employmentStatus"
            :data-test="fieldTrackerId.other"
            :items="employmentStatusOther"
            :placeholder="helpers.getPlaceholderResponsiveText('Please select employment status', isMobile)"
            :error-messages="errors"
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import {
  omit,
  pick,
  snakeCase,
} from 'lodash';
import {
  inject,
} from '@vue/composition-api';

export default {
  name: 'question-employment-status',
  extends: QuestionBase,
  data () {
    return {
      fields: ['employmentStatus'],
    };
  },
  computed: {
    employmentStatusGenericModel: {
      get () {
        if (this.questionData.employmentStatus === null) return null;
        return this.constants.EMPLOYMENT_STATUS_FAVORITES.includes(this.questionData.employmentStatus) ? this.questionData.employmentStatus : true;
      },
      set (val) {
        this.questionData.employmentStatus = val.logical ? val.logicalValue : val.value;
      },
    },
    computedHelpText () {
      if (this.productName === 'car' && this.isCarHelpTextR1visible) return `Please select the option that best represents where ${!this.isAdditional ? 'you' : 'they'} currently spend the majority of ${!this.isAdditional ? 'your' : 'their'} time. You will have the opportunity to add a secondary occupation later.`;
      return null;
    },
    employmentStatusOther () {
      return this.helpers.createOptions({ source: omit(this.constants.EMPLOYMENT_STATUS, this.constants.EMPLOYMENT_STATUS_FAVORITES) });
    },
    employmentStatusGeneric () {
      return [
        ...this.helpers.createOptions({ source: pick(this.constants.EMPLOYMENT_STATUS, this.constants.EMPLOYMENT_STATUS_FAVORITES) }),
        this.constants.OTHER_OPTIONS,
      ];
    },
    fieldTrackerId () {
      return {
        main: snakeCase(this.questionFields.employmentStatus),
        other: `${snakeCase(this.questionFields.employmentStatus)}_other`,
      };
    },
  },
  setup () {
    const { isCarHelpTextR1visible } = inject('abTastyControllerUI');

    return {
      isCarHelpTextR1visible,
    };
  },
};
</script>
